import { Parse } from 'src/boot/parse'

export function getOne ({ commit, rootState }, tableId) {
  commit('TABLES_LOADING', true)
  return new Parse.Query('Table')
    .get(tableId)
    .then(table => {
      commit('TABLES_SET_SELECTED', table)
    })
    .catch(error => {
      if (rootState.orders.current && rootState.orders.current.attributes && rootState.orders.current.get('table').id === tableId) {
        commit('TABLES_SET_ORDERS_TABLE', false)
        rootState.orders.current.unset('table')
      }
      console.log('#### Table get error:', error)
    }).then(() => {
      commit('TABLES_LOADING', false)
    })
}

export async function getAll ({ commit, rootState }) {
  commit('TABLES_LOADING', true)
  return await new Parse.Query('Table')
    .equalTo('business', rootState.business.business)
    .find()
    .then(tables => {
      commit('TABLES_SET', tables)
    })
    .catch(error => {
      console.log('#### Tables get error:', error)
    }).then(() => {
      commit('TABLES_LOADING', false)
    })
}

export async function setSelected ({ commit, rootState }, table) {
  commit('TABLES_SET_SELECTED', table)
}

export async function set ({ commit, rootState }, table) {
  commit('TABLES_SET_ORDERS_TABLE', table)
}
